export namespace DaDoccumentData {
  export interface DaDoccumentDataDataRule {
    source: string | null | undefined
    channelId: string | null | undefined
    idNo: string | null | undefined
  }
}
